<template>
  <modal title="Edit Terminal" width="35" :showModal="showModal" @close-modal="closeModal">
    <div class="my-3 font-semibold">
      Edit selected Terminal
    </div>
    <form class="flex flex-col gap-4 mt-3">
      <div class="new-location-form__single-input-wrapper">
        <label class="label">Terminal Name</label>
        <input type="text" class="input" v-model="editedLocation.locationName" />
      </div>
      <div class="new-location-form__single-input-wrapper">
        <label class="label">Address</label>
        <vue-google-autocomplete id="map2" ref="shipperAddress" :value="editedLocation.address" classname="input"
          placeholder="Enter address" v-on:placechanged="getAddress">
        </vue-google-autocomplete>
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">Country</label>
        <el-select filterable v-model="editedLocation.country" placeholder="Select">
          <el-option v-for="country in countries" :key="country" :label="country" :value="country">
          </el-option>
        </el-select>
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">State</label>
        <el-select filterable v-model="editedLocation.state" placeholder="Select">
          <el-option v-for="state in states" :key="state.name" :label="state.name" :value="state.name">
          </el-option>
        </el-select>
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">City</label>
        <el-select filterable v-model="editedLocation.city" placeholder="Select">
          <el-option v-for="city in cities" :key="city" :label="city" :value="city">
          </el-option>
        </el-select>
      </div>

      <div class="new-location-form__single-input-wrapper">
        <label class="label">ZIP Code</label>
        <input type="text" class="input" v-model="zipCode" />
      </div>
    </form>

    <div class="button-wrapper mt-5">
      <base-button text="Save" :disabled="disableButton" :loading="updatingLocation" @click="updateLocation" />
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Cancel</p>
    </div>
  </modal>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  props: ["showModal", "location"],
  components: {
    VueGoogleAutocomplete
  },
  data() {
    return {
      editedLocation: {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",

      },
      zipCode: "",
      updatingLocation: false,
      states: [],
      cities: [],
      countries: ["Nigeria"]
    };
  },
  computed: {
    disableButton() {

      return this.location?.city?.length == 0 || this.location?.locationName?.length == 0 || this.location?.address?.length == 0 || this.location?.country?.length == 0 ||
        this.location?.state?.length == 0 ? true : false
    },
    geoCoderPayload() {
      return {
        lat: null,
        long: null,
      };
    },
  },
  watch: {
    editedLocation: {
      deep: true,
      immediate: true,
      handler(val) {

        this.geoCoderPayload.lat = val.lat;
        this.geoCoderPayload.long = val.long;
        if (this.geoCoderPayload.lat && this.geoCoderPayload.long) {
          this.getGeoCoder()
        }
      }
    },

  },

  mounted() {

    delete this.location.userId;
    delete this.location.quantumOrgId;
    delete this.location.quantumLocationId;
    if (this.location.zipCode) {
      this.zipCode = this.location.zipCode;
      delete this.location.zipCode;
    } else {
      delete this.location.zipCode;
    }

    this.getAllStatesAndCities().then(() => {
      this.loadCities(this.location.state);
      this.editedLocation = this.location
    });
  },
  methods: {
    async getGeoCoder() {
      try {
        const response = await this.$_getStateNameWithDim(this.geoCoderPayload);
        this.editedLocation.country = response.data?.country
        this.editedLocation.state = response.data?.state.replace(" State", "")
        this.editedLocation.city = response.data?.city
        this.zipCode = response.data?.zipcode
      } catch (error) {
        this.handleError();
      }
    },
    loadCities(val) {
      this.cities = [];
      if (val?.length > 0) {
        this.cities = [...this.states.find(state => state?.name == val.replace(' State', ""))?.cities]
      }
    },
    getAddress(addressData) {
      this.editedLocation.address = addressData.route;
      this.editedLocation.lat = addressData.latitude;
      this.editedLocation.long = addressData.longitude;
    },
    async updateLocation() {
      delete this.location.createdAt;
      delete this.location.updatedat;
      this.updatingLocation = true;
      this.location.locationId = this.location.id;
      this.editedLocation.zipCode = this.zipCode;
      try {
        await this.$_update3plLocation(this.editedLocation);
        this.handleSuccessfulUpdate();
        this.updatingLocation = false;
      } catch (error) {
        this.handleError(error);
        this.updatingLocation = false;
      }
    },
    handleSuccessfulUpdate() {
      this.generateToast("Location Successfully updated!", "success");
      this.$emit("location-updated");
      this.closeModal();
      setTimeout(() => {
        this.$router.push({ name: "LocationAndTax" });
      }, 1000);
    },
    resetInputFields() {
      this.editedLocation = {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
      };
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.editedLocation.imageurl = response;
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.editedLocation.imageurl = null;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.row {
  padding-top: 1rem !important;
}

.kpa-summary {
  margin-top: 1rem;
}

.text-grey {
  color: #7a90a7;
}

li {
  list-style-type: initial !important;
  margin-left: 1rem;
  padding-top: 0.5rem;
}

.input {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
